import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DatasetModel from '../../../../../models/pipeline/steps/dataset';
import DatasetAttributeModel from '../../../../../models/pipeline/steps/dataset/dataset_attribute';
import {FEATURE_FLAGS} from '../../../../../services/feature_flags';
import {MENUS, createDatasetAttribute, QUERY_BUILDER_TYPES} from '../../../../../utils/query_utils';
import {nextMenuEvent} from '../../../../../services/query_builder_events';
import {queryBuilderState} from '../../../../../services/query_builder_state';
import DatasetAttributeComponent from './dataset_attribute';

export default class DatasetAttributeGroup extends Component {
    input = null;
    attributeRefs = [];
    AttributeComponent = DatasetAttributeComponent;

    constructor(props) {
        super(props);
        this.state = {
            groupId: Math.round(Math.random() * 1000),
            focusNextInput: false,
        };
    }

    componentWillMount() {
        this.updateDummyAttribute();
    }

    componentDidMount() {
        this.unbindNextMenuListener = nextMenuEvent.listen(() => {
            if (queryBuilderState.attribute.type === this.type && [MENUS.COLUMN, MENUS.COLUMN_AND_AGG].includes(queryBuilderState.menu)) {
                this.setState({focusNextInput: true});
            }
        });
    }

    componentDidUpdate(prevProps) {
        if (this.state.focusNextInput) {
            const attributeRef = this.attributeRefs[this.attributeRefs.length - 1];
            attributeRef[queryBuilderState.menu === MENUS.COLUMN ? 'columnInput' : 'combinedInput'].focusInput();
            this.setState({focusNextInput: false});
        }
        if (prevProps.dataset !== this.props.dataset) {
            this.updateDummyAttribute();
        }
    }

    componentWillUnmount() {
        this.unbindNextMenuListener();
    }

    updateDummyAttribute() {
        const dummyAttribute = createDatasetAttribute(this.type, this.props.dataset);
        this.setState({dummyAttribute});
    }

    focusDummyAttribute() {
        this.attributeRefs[this.attributeRefs.length - 1].focusInput();
    }

    render() {
        let {attributes, onRemove, datasetOpen} = this.props;
        const {dummyAttribute} = this.state;
        const {AttributeComponent, attributeRefs} = this;
        let dummyAdded = false;

        if (dummyAttribute && (attributes.length === 0 || attributes[attributes.length - 1].isComplete())) {
            dummyAdded = true;
            attributes = attributes.concat([dummyAttribute]);
        }
        return (
            <>
                {attributes.map((attribute, i) => (
                    <div key={`${attribute.id}_${i}`} className={FEATURE_FLAGS.FILTERS_BESIDE ? 'filters-beside-column' : ''}>
                        {!FEATURE_FLAGS.QUERY_BUILDER_TYPE === QUERY_BUILDER_TYPES.COLUMN_FIRST && i > 0 && (i < attributes.length - 1 || !dummyAdded) && (
                            <span className="query-builder-filler">&</span>
                        )}
                        <AttributeComponent
                            attribute={attribute}
                            onRemove={() => onRemove(attribute)}
                            firstInList={i === 0}
                            position={i}
                            totalAttributes={attributes.length}
                            ref={(el) => { attributeRefs[i] = el; }}
                            datasetOpen={datasetOpen}
                        />
                    </div>
                ))}
            </>
        );
    }
}

DatasetAttributeGroup.propTypes = {
    dataset: PropTypes.instanceOf(DatasetModel).isRequired,
    attributes: PropTypes.arrayOf(PropTypes.instanceOf(DatasetAttributeModel)).isRequired,
    onRemove: PropTypes.func.isRequired,
    datasetOpen: PropTypes.bool,
};

DatasetAttributeGroup.defaultProps = {
    selectedInput: null,
};
